module.exports = __webpack_public_path__ + "static/img/9.8047e02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/9.png
// module id = FU7l
// module chunks = 0